import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { SchedulesRoutePage } from "../app/schedulesRoute";

export const Route = createFileRoute("/schedules")({
  component: SchedulesRoute,
});

function SchedulesRoute(): JSX.Element {
  const search = Route.useSearch();
  return <SchedulesRoutePage search={search} />;
}
